import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions, ResponseContentType } from '@angular/http';
import { Observable } from "rxjs/Observable";

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/catch';

import * as globalConst from './../../../constants';

@Injectable()
export class MonitorService {

	private apiUrl = globalConst.baseAPI;

	constructor(private http: Http) { }

	getStatus() {
		return this.http
		.get(this.apiUrl + "monitor/v1/statusservicos", JSON.parse(localStorage.getItem('yara.connectionHeader')))
		.map((res: Response) => res.json())
		.catch(e => {
			if (e.status === 401) {
				return Observable.throw('Unauthorized');
			}
		});
	}

	getQuantitys() {
		return this.http
		.get(this.apiUrl + "monitor/v1/quantidadesfilas", JSON.parse(localStorage.getItem('yara.connectionHeader')))
		.map((res: Response) => res.json())
		.catch(e => {
			if (e.status === 401) {
				return Observable.throw('Unauthorized');
			}
		});
	}

	getPeriod(dates) {
		return this.http
		.post(this.apiUrl + "monitor/v1/grafico", dates, JSON.parse(localStorage.getItem('yara.connectionHeader')))
		.map((res: Response) => res.json())
		.catch(e => {
			if (e.status === 401) {
				return Observable.throw('Unauthorized');
			}
		});
	}

	getVolumes(dates) {
		return this.http
		.post(this.apiUrl + "monitor/v1/totalprocessado", dates, JSON.parse(localStorage.getItem('yara.connectionHeader')))
		.map((res: Response) => res.json())
		.catch(e => {
			if (e.status === 401) {
				return Observable.throw('Unauthorized');
			}
		});
	}	

	getErrorMessages(dates) {
		return this.http
		.post(this.apiUrl + "monitor/v1/mensagenserro", dates, JSON.parse(localStorage.getItem('yara.connectionHeader')))
		.map((res: Response) => res.json())
		.catch(e => {
			if (e.status === 401) {
				return Observable.throw('Unauthorized');
			}
		});
	}

	getErrorMessagesExcel(dates) {
		let localStorageOptions = JSON.parse(localStorage.getItem('yara.connectionHeader'))
		const options = new RequestOptions({ headers: localStorageOptions.headers, responseType: ResponseContentType.Blob });
		return this.http
			.post(this.apiUrl + "monitor/v1/mensagensexcel", dates, options)
			.map(res => {
				return new Blob([res.blob()], { type: "application/octet-stream" });
			});
	}


	getByOv(obj, type) {
		let url;

		switch(type) {
			case "notificações":
				url = "monitor/v1/ovnotificacoes";
			break;
			case "envios":
				url = "monitor/v1/ovenvios";
			break;
			case "mensagens":
				url = "monitor/v1/ovmensagens";
			break;
			default:
			break;
		}

		return this.http
		.post(this.apiUrl + url, obj, JSON.parse(localStorage.getItem('yara.connectionHeader')))
		.map((res: Response) => res.json())
		.catch(e => {
			if (e.status === 401) {
				return Observable.throw('Unauthorized');
			}
		});
	}

	getByOvExcel(dates) {
		let localStorageOptions = JSON.parse(localStorage.getItem('yara.connectionHeader'))
		const options = new RequestOptions({ headers: localStorageOptions.headers, responseType: ResponseContentType.Blob });
		return this.http
			.post(this.apiUrl + "monitor/v1/ovexcel", dates, options)
			.map(res => {
				return new Blob([res.blob()], { type: "application/octet-stream" });
			});
	}

	

}



// WEBPACK FOOTER //
// ./src/app/monitor/service/monitor.service.ts